<ng-content />

@if (products) {
  <div class="wrapper">
    @for (item of [].constructor(2); track item; let i = $index) {
      <mkp-product-comparison-table-column-header
        [products]="products"
        [isProductLoading]="isProductLoading"
        [isReadMode]="isReadMode"
        [defaultSelectedProductCode]="defaultSelectedProductCodes[i]"
        (handleSelectedProduct)="handleSelectedProduct.emit($event)"
        (handleChosenProduct)="chosenProduct($event, i)"
      />
    }
  </div>
  <span class="title-lead feature-title">{{ 'PRODUCT_OFFERING.FEATURES' | translate }}</span>
  @if (selectedProducts?.length) {
    <!-- calendar feature -->
    <mkp-product-comparison-table-features
      [products]="selectedProducts"
      [feature]="calendarFeature"
    />
    <!-- platforms -->
    @for (platform of platforms; track platform) {
      <mkp-product-comparison-table-features [products]="selectedProducts" [feature]="platform" />
    }
    <!-- benefits -->
    @for (benefit of benefits; track benefit) {
      <mkp-product-comparison-table-features [products]="selectedProducts" [feature]="benefit" />
    }
  }
} @else {
  @for (item of [].constructor(4); track item) {
    <mkp-product-table-skeleton />
  }
}
